(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-return-policy"] && !Shopify.designMode) return;
  try {
    (function () {
    var OPEN_CLASS = 'cart-return-policy--open';

    function closeAll(except) {
      document.querySelectorAll('[data-cart-return-policy].' + OPEN_CLASS).forEach(function (wrapper) {
        if (wrapper === except) return;
        wrapper.classList.remove(OPEN_CLASS);
        var trigger = wrapper.querySelector('[data-cart-return-policy-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var trigger = target.closest('[data-cart-return-policy-trigger]');
      if (trigger) {
        var wrapper = trigger.closest('[data-cart-return-policy]');
        if (!wrapper) return;
        var isOpen = wrapper.classList.toggle(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        closeAll(wrapper);
        return;
      }

      if (target.closest('[data-cart-return-policy-close]')) {
        closeAll();
        return;
      }

      if (!target.closest('[data-cart-return-policy-popup]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var open = document.querySelector('[data-cart-return-policy].' + OPEN_CLASS);
      if (!open) return;
      closeAll();
      var trigger = open.querySelector('[data-cart-return-policy-trigger]');
      if (trigger) trigger.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
